import React, { useState, useRef, useCallback } from "react";
import { toast } from 'react-toastify';

import api from '../../../../api/api';
import { ShareLessonBySocket, notificationIsView } from '../../../../api/realtime';
import history from '../../../../history';
import { getPathList } from './utils';

export const useLessonItem = (props) => {
    const {
        lesson,
        user,
        type,
        indices,
        setLessonIsView,
        fetchLesson,
        removeCurrentLessons,
        clearLessonQuestions,
        getStudent,
        lessonQuestions,
        studentInClassRooms,
        classRooms,
        fetchClassRooms,
        t,
        setIndex,
        LessonId
    } = props;

    const toastId = useRef(null);

    const [moreInfo, setMoreInfo] = useState(false);
    const [SelectedQuestions, setSelectedQuestions] = useState([]);
    const [showCopy, setShowCopy] = useState(false);
    const [showPlayer, setShowPlayer] = useState(false);
    const [showDoneCopy, setShowDoneCopy] = useState(false);
    const [showSendMission, setShowSendMission] = useState(false);
    const [showShare, setShowShare] = useState(false);
    const [AllQuestion, setAllQuestionState] = useState(true);
    const [copyId, setCopyId] = useState(0);
    const [src, setSrc] = useState("");
    const [studentType, setStudentType] = useState("all");
    const [SelectCustomeQuestions, setSelectCustomeQuestionsState] = useState(false);
    const [ClassRoomId, setClassRoomId] = useState("");
    const [currentItem, setCurrentItem] = useState(null);

    const setAllQuestion = useCallback((value) => {
        setAllQuestionState(value);
        if (!value && lesson) {
            removeCurrentLessons && removeCurrentLessons();
            fetchLesson && fetchLesson(lesson.Id);
        }
    }, [lesson, removeCurrentLessons, fetchLesson]);

    const toggleMoreInfo = useCallback(() => {
        setMoreInfo(prev => !prev);
    }, []);

    const showCopyModal = useCallback(() => {
        setShowCopy(true);
        setSrc(process.env.PUBLIC_URL + "/assets/effect/public/8170-file-printer.json");
    }, []);

    const showSendMissionModal = useCallback(() => {
        if ((!classRooms || !classRooms.classRooms || classRooms.classRooms.length === 0) && fetchClassRooms) {
            const getAllClass = user?.user?.UserType?.Id === 3;
            fetchClassRooms(getAllClass);
        }
        setShowSendMission(true);
    }, [classRooms, fetchClassRooms, user]);

    const showShareModal = useCallback(() => {
        if ((!classRooms || !classRooms.classRooms || classRooms.classRooms.length === 0) && fetchClassRooms) {
            const getAllClass = user?.user?.UserType?.Id === 3;
            fetchClassRooms(getAllClass);
        }
        setShowShare(true);
        setClassRoomId("");
    }, [classRooms, fetchClassRooms, user]);

    const handleClose = useCallback(() => {
        setShowCopy(false);
        setShowShare(false);
        setShowSendMission(false);
        setAllQuestionState(true);
        if (removeCurrentLessons) {
            removeCurrentLessons();
        }
    }, [removeCurrentLessons]);

    const handleSetIndex = useCallback((node) => {
        if (setIndex) {
            setIndex(node);
        } else if (lesson) {
            const list = getPathList(indices, lesson.Index.Id, 0);
            if (list && list.length >= 2) {
                history.push(`/${list[1].type}/${list[0].id}/${node.id}`);
            }
        }
    }, [setIndex, lesson, indices]);

    const openViewWindow = useCallback((Id) => {
        if (user && user.user) {
            if (lesson && lesson.IsView === false && user.user.UserType.Id === 5) {
                if (lesson.Index.Type === "Exams") {
                    notificationIsView("EXAMS", user.user.Id);
                } else if (lesson.Index.Type === "Quizzes") {
                    notificationIsView("QUIZZES", user.user.Id);
                } else if (lesson.Index.Type === "Lessons") {
                    notificationIsView("LESSON", user.user.Id);
                } else if (lesson.Index.Type === "Games") {
                    notificationIsView("GAMES", user.user.Id);
                } else if (lesson.Index.Type === "SelfDevelopment") {
                    notificationIsView("SELFDEVELOPMENT", user.user.Id);
                } else {
                    notificationIsView("BOOK", user.user.Id);
                }
                setLessonIsView && setLessonIsView(lesson.Id);
            }
            if (type === "Exams" || type === "Quizzes") {
                window.openExamView(Id);
            } else if (type === "Games" || type === "Fun") {
                window.openGameView(Id);
            } else if (type === "SelfDevelopment") {
                window.openSelfDevelopmentView(Id);
            } else {
                window.openLessonView(Id);
            }
        } else {
            history.push("/Login");
        }
    }, [user, lesson, setLessonIsView, type]);

    const openPDFViewWindow = useCallback((Id) => {
        if ((user && user.user) || (lesson && lesson.IsPublic)) {
            window.openPDFViewWindow(Id);
        } else {
            history.push("/Login");
        }
    }, [user, lesson]);

    const handleCopy = useCallback((id) => {
        let IndexId = currentItem ? parseInt(currentItem.id) : 0;

        toastId.current = toast(t('Processing'), {
            position: "bottom-left",
            autoClose: false
        });
        toast.update(toastId.current, {
            render: () => <div> <i className="fa-spin fas fa-spinner "></i> {t('Processing')} </div>,
            autoClose: false,
            closeOnClick: false,
        });

        if (IndexId) {
            setShowPlayer(true);
            api.post(`/LessonCopy/${id}`, {
                IndexId,
                Questions: SelectedQuestions
            }).then(response => {
                if (response.data.data.Id !== 0) {
                    toast.update(toastId.current, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-copy"></i> {t('Success.CopyLesson.Title')}</div> <div className="h6">{t('Success.CopyLesson.Body')}</div></div>,
                        type: toast.TYPE.SUCCESS,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });

                    setCopyId(response.data.data.Id);
                    setShowDoneCopy(true);
                    setAllQuestionState(true);
                    setSelectedQuestions([]);
                    setSrc(process.env.PUBLIC_URL + "/assets/effect/public/9917-success.json");
                } else {
                    toast.update(toastId.current, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-exclamation-triangle"></i> {t('Error.CopyError.Title')}</div> <div className="h6">{t('Error.CopyError.Body')}</div></div>,
                        type: toast.TYPE.ERROR,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
            }).catch(() => {
                setShowDoneCopy(false);
                setShowCopy(false);
                toast.update(toastId.current, {
                    render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                    type: toast.TYPE.ERROR,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
        } else {
            toast.update(toastId.current, {
                render: () => <div><div className="h5"> <i className="icon fal fa-exclamation-triangle"></i> {t('Error.IndexNotSelected.Title')}</div> <div className="h6">{t('Error.IndexNotSelected.Body')}</div></div>,
                type: toast.TYPE.ERROR,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }, [currentItem, SelectedQuestions, t]);

    const handleChangeSelect = useCallback((isChecked, QuestionId) => {
        setSelectedQuestions(prev => {
            if (isChecked) {
                return [...prev, QuestionId];
            } else {
                return prev.filter(p => p !== QuestionId);
            }
        });
    }, []);

    const onChangeClassRoom = useCallback((id) => {
        setClassRoomId(id);
    }, []);

    const ShowToAll = useCallback((classRoomIdParam, lessonIdParam) => {
        toastId.current = toast(t('Processing'), {
            position: "bottom-left",
            autoClose: false
        });
        toast.update(toastId.current, {
            render: () => <div> <i className="fa-spin fas fa-spinner "></i> {t('Processing')} </div>,
            autoClose: false,
            closeOnClick: false,
        });

        api.post(`/LessonPermissions/${classRoomIdParam}`, {
            isAdd: true,
            LessonId: lessonIdParam,
            StudentType: studentType,
            Questions: SelectedQuestions
        }).then(response => {
            if (response.data.code === "success") {
                toast.update(toastId.current, {
                    render: () => <div>
                        <div className="h5">
                            <i className="icon fal fa-mind-share"></i>
                            {type === "Games" ? t("Success.GamesPermissionShow.Title") : t("Success.LessonPermissionShow.Title")}
                        </div>
                        <div className="h6">
                            {type === "Games" ? t("Success.GamesPermissionShow.Body") : t("Success.LessonPermissionShow.Body")}
                        </div>
                    </div>,
                    type: toast.TYPE.SUCCESS,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                });
                getStudent && getStudent(classRoomIdParam, lessonIdParam);

                if (studentInClassRooms && studentInClassRooms.studentInClassRooms) {
                    let studentList = studentInClassRooms.studentInClassRooms.map(p => p.Id);
                    if (studentList) {
                        ShareLessonBySocket(studentList, lesson, type);
                    }
                }
            } else {
                toast.update(toastId.current, {
                    render: () => <div>
                        <div className="h5">
                            <i className="icon fal fa-exclamation-triangle"></i>
                            {t('Error.LessonPermissions.Title')}
                        </div>
                        <div className="h6">
                            {t('Error.LessonPermissions.Body')}
                        </div>
                    </div>,
                    type: toast.TYPE.ERROR,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        }).catch(() => {
            toast.update(toastId.current, {
                render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                type: toast.TYPE.ERROR,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });
    }, [t, studentType, SelectedQuestions, type, getStudent, studentInClassRooms, lesson]);

    const HideFromAll = useCallback((classRoomIdParam, lessonIdParam) => {
        toastId.current = toast(t('Processing'), {
            position: "bottom-left",
            autoClose: false
        });
        toast.update(toastId.current, {
            render: () => <div> <i className="fa-spin fas fa-spinner "></i> {t('Processing')} </div>,
            autoClose: false,
            closeOnClick: false,
        });

        api.post(`/LessonPermissions/${classRoomIdParam}`, {
            isAdd: false,
            LessonId: lessonIdParam,
            StudentType: studentType
        }).then(response => {
            if (response.data.code === "success") {
                toast.update(toastId.current, {
                    render: () => <div>
                        <div className="h5">
                            <i className="icon fal fa-mind-share"></i>
                            {type === "Games" ? t("Success.GamesPermissionHide.Title") : t("Success.LessonPermissionHide.Title")}
                        </div>
                        <div className="h6">
                            {type === "Games" ? t("Success.GamesPermissionHide.Body") : t("Success.LessonPermissionHide.Body")}
                        </div>
                    </div>,
                    type: toast.TYPE.SUCCESS,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                });
                getStudent && getStudent(classRoomIdParam, lessonIdParam);
            } else {
                toast.update(toastId.current, {
                    render: () => <div><div className="h5"> <i className="icon fal fa-exclamation-triangle"></i> {t('Error.LessonPermissions.Title')}</div> <div className="h6">{t('Error.LessonPermissions.Body')}</div></div>,
                    type: toast.TYPE.ERROR,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        }).catch(() => {
            toast.update(toastId.current, {
                render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                type: toast.TYPE.ERROR,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });
    }, [t, studentType, type, getStudent]);

    const setSelectCustomeQuestions = useCallback((value) => {
        setSelectCustomeQuestionsState(value);
        if (value && lessonQuestions && lessonQuestions.LessonId !== LessonId) {
            clearLessonQuestions && clearLessonQuestions();
        }
    }, [lessonQuestions, LessonId, clearLessonQuestions]);

    const copyIdToClipboard = useCallback((Id) => {
        navigator.clipboard.writeText(Id);

        toastId.current = toast(t('Processing'), {
            position: "bottom-left",
            autoClose: false
        });
        toast.update(toastId.current, {
            render: () => <div> <i className="fa-spin fas fa-spinner "></i> {t('Processing')} </div>,
            autoClose: false,
            closeOnClick: false,
        });

        toast.update(toastId.current, {
            render: () => <div>
                <div className="h5">
                    <i className="icon fal fa-clipboard"></i>
                    {t('Pages.Templates.copy_to_clipboard.Title')}
                </div>
                <div className="h6">
                    {t('Pages.Templates.copy_to_clipboard.Body')}
                </div>
            </div>,
            type: toast.TYPE.INFO,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
        });
    }, [t]);

    return {
        moreInfo,
        toggleMoreInfo,
        SelectedQuestions,
        setSelectedQuestions,
        showCopy,
        showPlayer,
        showDoneCopy,
        showSendMission,
        showShare,
        AllQuestion,
        setAllQuestion,
        copyId,
        src,
        studentType,
        setStudentType,
        SelectCustomeQuestions,
        setSelectCustomeQuestions,
        ClassRoomId,
        onChangeClassRoom,
        currentItem,
        setCurrentItem,
        showCopyModal,
        showSendMissionModal,
        showShareModal,
        handleClose,
        handleSetIndex,
        openViewWindow,
        openPDFViewWindow,
        handleCopy,
        handleChangeSelect,
        ShowToAll,
        HideFromAll,
        copyIdToClipboard,
        setSelect: setSelectedQuestions
    };
};

export default useLessonItem;
